var _path, _path2, _circle, _path3, _ellipse, _path4, _path5, _path6, _path7, _circle2, _ellipse2, _path8, _path9, _path10, _path11, _circle3, _rect, _rect2, _rect3, _rect4, _circle4, _circle5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 159,
    viewBox: "0 0 129 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.381 74.929C114.381 99.9971 92.6081 120.319 65.7494 120.319C38.8908 120.319 17.1176 99.9971 17.1176 74.929C17.1176 49.8609 38.8908 29.5393 65.7494 29.5393C92.6081 29.5393 114.381 49.8609 114.381 74.929Z",
    fill: "url(#paint0_linear_729_377)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7868 19.4526H68.9916V30.9802H61.7868V19.4526Z",
    fill: "url(#paint1_linear_729_377)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65.3892,
    cy: 10.8071,
    r: 10.0866,
    fill: "#000F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1097 123.921C94.7589 123.921 117.984 102.309 117.984 75.6495C117.984 59.5305 109.493 45.2567 96.4473 36.4894C95.2359 35.6754 93.796 35.2842 92.3365 35.2842H39.8829C38.4233 35.2842 36.9834 35.6754 35.772 36.4894C22.7259 45.2567 14.2357 59.5305 14.2357 75.6495C14.2357 102.309 37.4604 123.921 66.1097 123.921Z",
    fill: "url(#paint2_linear_729_377)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.1943,
    cy: 106.61,
    rx: 3.81435,
    ry: 7.1519,
    transform: "rotate(-44.9872 29.1943 106.61)",
    fill: "#236DC1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.189 113.724C39.1439 111.74 37.5117 106.962 33.5434 103.052C29.5752 99.1426 24.7736 97.5816 22.8187 99.5657C20.8639 101.55 22.4961 106.328 26.4643 110.237C30.4326 114.147 35.2342 115.708 37.189 113.724ZM33.7799 111.18C35.0237 109.918 33.9852 106.877 31.4602 104.39C28.9353 101.902 25.8801 100.909 24.6362 102.171C23.3924 103.434 24.4309 106.474 26.9559 108.962C29.4808 111.449 32.5361 112.443 33.7799 111.18Z",
    fill: "#468BDC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8351 108.702L34.4771 106.253L29.5794 100.969L26.9374 103.418L31.8351 108.702ZM12.2481 101.947L15.2339 99.9315L15.2339 99.9315L12.2481 101.947ZM15.3053 82.9129C15.9344 81.0254 14.9144 78.9853 13.027 78.3562C11.1395 77.727 9.09943 78.7471 8.47027 80.6345L15.3053 82.9129ZM26.9374 103.418C25.1365 105.087 23.3647 105.578 21.7482 105.275C20.0419 104.956 17.7108 103.601 15.2339 99.9315L9.26224 103.962C12.3887 108.594 16.1817 111.562 20.4211 112.357C24.7503 113.168 28.7459 111.565 31.8351 108.702L26.9374 103.418ZM15.2339 99.9315C13.6529 97.5893 13.0016 96.4805 12.8514 94.6696C12.6807 92.6114 13.1647 89.3344 15.3053 82.9129L8.47027 80.6345C6.2879 87.1814 5.37147 91.6496 5.67137 95.2651C5.99178 99.1279 7.68213 101.621 9.26224 103.962L15.2339 99.9315Z",
    fill: "#000F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0825 108.449L34.471 105.752L29.0778 100.975L26.6892 103.671L32.0825 108.449ZM11.5275 100.866L8.58447 102.944L8.58447 102.944L11.5275 100.866ZM15.0498 84.3297C15.4666 82.3843 14.2275 80.4694 12.2822 80.0525C10.3368 79.6357 8.42183 80.8748 8.00499 82.8202L15.0498 84.3297ZM8.00499 82.8202C7.96596 83.0023 7.92693 83.1814 7.88795 83.3575L14.9223 84.9149C14.9648 84.7231 15.0073 84.5281 15.0498 84.3297L8.00499 82.8202ZM5.93726 91.0133C5.83462 91.4478 5.7407 91.884 5.66259 92.3205L12.7546 93.5897C12.8035 93.3167 12.8676 93.0142 12.949 92.6697L5.93726 91.0133ZM8.22238 102.421C8.33939 102.593 8.46009 102.768 8.58447 102.944L14.4705 98.7889C14.3691 98.6453 14.2729 98.5064 14.1816 98.3721L8.22238 102.421ZM8.58447 102.944C8.73068 103.151 8.87893 103.356 9.02914 103.56L14.8265 99.2822C14.7066 99.1197 14.5879 98.9552 14.4705 98.7889L8.58447 102.944ZM17.2093 111.049C17.7324 111.328 18.271 111.579 18.8237 111.796L21.462 105.092C21.1844 104.983 20.8957 104.85 20.5969 104.69L17.2093 111.049ZM31.4732 109.099C31.6804 108.89 31.8835 108.673 32.0825 108.449L26.6892 103.671C26.5781 103.797 26.4685 103.914 26.3606 104.022L31.4732 109.099Z",
    fill: "#0F4688"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8934 107.501C36.1282 106.021 34.9913 104.479 33.5434 103.052C31.298 100.84 28.7857 99.3797 26.6733 98.8882L27.5647 101.873C28.8003 102.274 30.1967 103.145 31.4602 104.39C32.4734 105.388 33.2472 106.475 33.7303 107.501H36.8934Z",
    fill: "#468BDC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.3688,
    cy: 78.9318,
    r: 7.65502,
    transform: "rotate(-30.6263 13.3688 78.9318)",
    fill: "#85B7F2"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.81435,
    cy: 7.1519,
    rx: 3.81435,
    ry: 7.1519,
    transform: "matrix(-0.707265 -0.706949 -0.706949 0.707265 110.063 104.248)",
    fill: "#236DC1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.3142 113.724C92.3594 111.74 93.9916 106.962 97.9598 103.052C101.928 99.1428 106.73 97.5818 108.684 99.566C110.639 101.55 109.007 106.328 105.039 110.238C101.071 114.147 96.269 115.708 94.3142 113.724ZM97.7233 111.18C96.4795 109.918 97.518 106.878 100.043 104.39C102.568 101.902 105.623 100.909 106.867 102.172C108.111 103.434 107.072 106.474 104.547 108.962C102.022 111.45 98.9672 112.443 97.7233 111.18Z",
    fill: "#468BDC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2867 108.288L97.0584 105.458L102.719 101.001L104.948 103.832L99.2867 108.288ZM103.455 150.321C101.608 151.06 99.5114 150.162 98.7725 148.314C98.0336 146.467 98.9321 144.371 100.779 143.632L103.455 150.321ZM104.948 103.832C107.663 107.28 109.298 112.059 110.271 116.289C111.261 120.592 111.673 124.818 111.673 127.524L104.469 127.524C104.469 125.398 104.126 121.714 103.249 117.904C102.356 114.021 101.015 110.483 99.2867 108.288L104.948 103.832ZM111.673 127.524C111.673 130.451 110.481 135.591 109.218 139.777C108.565 141.944 107.832 144.055 107.116 145.717C106.762 146.537 106.372 147.344 105.954 148.021C105.746 148.358 105.482 148.742 105.158 149.102C104.877 149.413 104.314 149.978 103.455 150.321L100.779 143.632C100.145 143.885 99.8257 144.256 99.8042 144.28C99.739 144.352 99.7488 144.357 99.8265 144.231C99.98 143.983 100.21 143.538 100.499 142.866C101.068 141.545 101.711 139.716 102.321 137.696C103.584 133.506 104.469 129.279 104.469 127.524L111.673 127.524Z",
    fill: "#000F20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2864 108.288L97.0581 105.458L102.719 101.001L104.947 103.832L99.2864 108.288ZM108.071 126.803L104.468 126.803L108.071 126.803ZM105.851 147.581C104.92 149.34 102.74 150.01 100.982 149.08C99.2234 148.149 98.5526 145.969 99.4835 144.21L105.851 147.581ZM99.4835 144.21C99.5708 144.045 99.6576 143.878 99.7437 143.709L106.166 146.974C106.062 147.178 105.957 147.38 105.851 147.581L99.4835 144.21ZM102.729 136.17C102.844 135.794 102.953 135.419 103.058 135.047L109.994 136.993C109.876 137.417 109.751 137.843 109.621 138.27L102.729 136.17ZM104.459 127.293C104.465 127.12 104.468 126.957 104.468 126.803L111.673 126.803C111.673 127.052 111.668 127.304 111.659 127.558L104.459 127.293ZM104.468 126.803C104.468 126.62 104.466 126.425 104.46 126.216L111.663 126.029C111.67 126.295 111.673 126.554 111.673 126.803L104.468 126.803ZM103.238 117.496C103.139 117.09 103.034 116.683 102.922 116.279L109.868 114.364C110 114.842 110.123 115.321 110.239 115.796L103.238 117.496ZM99.6032 108.71C99.4984 108.564 99.3928 108.423 99.2864 108.288L104.947 103.832C105.121 104.052 105.29 104.277 105.453 104.504L99.6032 108.71Z",
    fill: "#0F4688"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.6099 107.501C95.375 106.021 96.5119 104.479 97.9598 103.052C100.205 100.84 102.718 99.3799 104.83 98.8884L103.939 101.873C102.703 102.274 101.307 103.145 100.043 104.39C99.0298 105.388 98.256 106.475 97.7729 107.501H94.6099Z",
    fill: "#468BDC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 99.8255,
    cy: 148.097,
    r: 7.65502,
    transform: "rotate(-30.6263 99.8255 148.097)",
    fill: "#86B8F3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 62.6811,
    y: 108.071,
    width: 1.08071,
    height: 7.56496,
    rx: 0.540354,
    fill: "#5998E1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 69.1654,
    y: 108.071,
    width: 1.08071,
    height: 7.56496,
    rx: 0.540354,
    fill: "#5998E1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 65.9232,
    y: 105.909,
    width: 1.08071,
    height: 12.9685,
    rx: 0.540354,
    fill: "#5998E1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 25.937,
    y: 43.9487,
    width: 83.5748,
    height: 43.9488,
    rx: 21.9744,
    fill: "#000F20",
    stroke: "#458DDE",
    strokeWidth: 2.88189
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.0728,
    cy: 58.7185,
    r: 6.12402,
    fill: "#72B2FF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.0964,
    cy: 58.7185,
    r: 6.12402,
    fill: "#72B2FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_729_377",
    x1: 65.7494,
    y1: 19.4526,
    x2: 65.7494,
    y2: 120.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#7E9DC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_729_377",
    x1: 65.7494,
    y1: 19.4526,
    x2: 65.7494,
    y2: 120.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#7E9DC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_729_377",
    x1: 66.1097,
    y1: 27.3779,
    x2: 66.1097,
    y2: 123.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83B5F1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.4d1d639d152900f4da2b5744046937e6.svg";
export { ForwardRef as ReactComponent };